<ion-tabs>
    <ion-tab-bar slot="bottom" color="primary">

        <ion-tab-button data-test="tagAnalysisTab" label="Tag Analysis" tab="tagAnalysis">
            <ion-icon name="git-branch"></ion-icon>
            <ion-label>Analysis</ion-label>
        </ion-tab-button>

        <ion-tab-button data-test="activitiesTab" label="Activities" tab="activities">
            <ion-icon name="checkbox-outline"></ion-icon>
            <ion-label>Activities</ion-label>
        </ion-tab-button>

        <ion-tab-button data-test="prospectsTab" label="Prospects" tab="prospects">
            <ion-icon name="home"></ion-icon>
            <ion-label>Propects</ion-label>
        </ion-tab-button>

        <ion-tab-button data-test="contactsTab" label="Contacts" tab="contacts">
            <ion-icon name="people"></ion-icon>
            <ion-label>Contacts</ion-label>
        </ion-tab-button>

        <ion-tab-button data-test="setupTab" label="Setup" tab="setup">
            <ion-icon name="construct"></ion-icon>
            <ion-label>Setup</ion-label>
        </ion-tab-button>

    </ion-tab-bar>
</ion-tabs>
